/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { Store } from '@ngrx/store';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, distinctUntilChanged, Subscription, take, mergeMap, of, skip, filter } from 'rxjs';
import { AnswersheetAnswerInterface } from '../../../models/interface/answersheet-answer.interface';
import { ConditionalblockInterface } from '../../../models/interface/condition/conditionalblock.interface';
import { QuestionHeadlineInterface } from '../../../models/interface/elements-question/question-headline/question-headline.interface';
import { QuestionMediaInterface } from '../../../models/interface/elements-question/question-media/question-media.interface';
import { QuestionSliderInterface } from '../../../models/interface/elements-question/question-slider/question-slider.interface';
import { QuestionTableInterface } from '../../../models/interface/elements-question/question-table/question-table.interface';
import { QuestionTextAreaInterface } from '../../../models/interface/elements-question/question-text-area/question-text-area.interface';
import { QuestionTextDateInterface } from '../../../models/interface/elements-question/question-text-date/question-text-date.interface';
import { QuestionTextStringInterface } from '../../../models/interface/elements-question/question-text-string/question-text-string.interface';
import { QuestionTextInterface } from '../../../models/interface/elements-question/question-text/question-text.interface';
import { QuestionYesNoInterface } from '../../../models/interface/elements-question/question-yes-no/question-yes-no.interface';
import { ElementBlockInterface } from '../../../models/interface/elements/element-block.interface';
import { ElementInterface } from '../../../models/interface/elements/element.interface';
import { InterventionInterface } from '../../../models/interface/intervention.interface';
import { LessonInterface } from '../../../models/interface/lesson.interface';
import { EvaluationService } from '../../../services/evaluation/evaluation.service';
import { HelperService } from '../../../services/helper/helper.service';
import { ParserService } from '../../../services/parser/parser.service';
import { PageIterationInterface } from '../../../models/interface/elements/page-iteration.interface';
import { ElementsBlockopensComponent } from '../../questionnaire-element/components/elements-blockopens/elements-blockopens.component';
import { ElementsLinesComponent } from '../../questionnaire-element/components/elements-lines/elements-lines.component';
import { ElementsPageComponent } from '../../questionnaire-element/components/elements-page/elements-page.component';
import { ElementsSpacesComponent } from '../../questionnaire-element/components/elements-spaces/elements-spaces.component';
import { QuestionHeadlineComponent } from '../../questionnaire-element/components/question-headline/question-headline.component';
import { QuestionMediaComponent } from '../../questionnaire-element/components/question-media/question-media.component';
import { QuestionMultipleChoiceComponent } from '../../questionnaire-element/components/question-multiple-choice/question-multiple-choice.component';
import { QuestionSingleChoiceComponent } from '../../questionnaire-element/components/question-single-choice/question-single-choice.component';
import { QuestionSliderComponent } from '../../questionnaire-element/components/question-slider/question-slider.component';
import { QuestionTableComponent } from '../../questionnaire-element/components/question-table/question-table.component';
import { QuestionTextAreaComponent } from '../../questionnaire-element/components/question-text-area/question-text-area.component';
import { QuestionTextDateComponent } from '../../questionnaire-element/components/question-text-date/question-text-date.component';
import { QuestionTextStringComponent } from '../../questionnaire-element/components/question-text-string/question-text-string.component';
import { QuestionTextComponent } from '../../questionnaire-element/components/question-text/question-text.component';
import { QuestionYesNoComponent } from '../../questionnaire-element/components/question-yes-no/question-yes-no.component';
import { ProgressBarComponent } from '../../questionnaire-element/progress-bar/progress-bar.component';
import { QuestionnaireStore } from '../../../store/lesson-questionnaire/component-store/lesson-questionnaire.store';
import { SkillStore } from '../../../store/skill/component-store/skill.store';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { LessonLocaleActionTypes } from 'src/app/store/lesson-locale/lesson-locale.action';
import { SkillInterface } from 'src/app/models/interface/skill.interface';
import { DiaryInterface } from 'src/app/models/interface/diary.interface';
import { ConditionElementInterface } from 'src/app/models/interface/condition/condition-element.interface';

@Component({
  selector: 'app-questionnaire-preview',
  templateUrl: './questionnaire-preview.component.html',
  styleUrls: ['./questionnaire-preview.component.scss'],
  providers: [QuestionnaireStore, SkillStore]
})
export class QuestionnairePreviewComponent implements OnInit, OnDestroy {
  @ViewChild('elementsContainer', { read: ViewContainerRef }) elementsContainer: ViewContainerRef;
  @ViewChild('progressBarContainer', { read: ViewContainerRef }) progressBarContainer: ViewContainerRef;

  @ViewChild('topPage') topPage: ElementRef;

  // Icons
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faEye = faEye;

  public nonNestedElements: Array<
    | ElementInterface
    | QuestionHeadlineInterface
    | QuestionMediaInterface
    | QuestionYesNoInterface
    | QuestionTextInterface
    | QuestionTextStringInterface
    | QuestionTextDateInterface
    | QuestionTextAreaInterface
    | QuestionTableInterface
    | QuestionSliderInterface
    | ElementBlockInterface
  > = [];

  public isDiary = false;
  public diaryDefaultImageColor: string;
  public studyId: number;

  public lesson: LessonInterface;
  private diary: DiaryInterface;
  private skill: SkillInterface;

  // Background color
  public backgroundColor: string;

  private inputElements: ElementInterface[] | null = null;

  public elements: ElementInterface[] = [];
  public blocks: ConditionalblockInterface[] = [];

  // Answers from answersheet
  public answers: AnswersheetAnswerInterface[];

  // Answers from elements
  public dynamicAnswers: AnswersheetAnswerInterface[] = [];

  public isCollapse$: Observable<boolean>;
  public isSmallLayout$: Observable<boolean>;

  public intervention: InterventionInterface;

  public currentPageNumber = 0;
  public pageIteration: PageIterationInterface[] = [];

  public isCollapseSubject = new BehaviorSubject<boolean>(false);

  public locales: string[] = [];

  public selectedLocale: string;

  private numbersOfPages: { pageElements: ElementInterface[] } = {
    pageElements: [],
  };

  private dynamicAnswers$: Observable<AnswersheetAnswerInterface[]>;

  private pages: ElementsPageComponent[] = [];

  // Tracks list of generated components
  private components: any[] = [];

  private progressBarComponent: ProgressBarComponent;

  private isSmallLayoutSubject = new BehaviorSubject<boolean>(false);

  private elementsOfQuestionnaire$: Observable<any[]>;
  private elementsOfSkill$: Observable<any>;

  private subscriptions: Subscription[] = [];
  private elementsType: 'questionnaires' | 'skills' = 'questionnaires';
  private skillId: number;

  constructor(
    private helperService: HelperService,
    private evaluationService: EvaluationService,
    private parserService: ParserService,
    private translateService: TranslateService,
    public myElement: ElementRef,
    private questionnaireStore: QuestionnaireStore,
    private skillStore: SkillStore,
    private store: Store<{
      dynamicAnswers: Array<AnswersheetAnswerInterface>;
      lessonLocale: string;
    }>,
  ) {
    this.dynamicAnswers$ = store.select('dynamicAnswers');
    this.isCollapse$ = this.isCollapseSubject.asObservable();
    this.isSmallLayout$ = this.isSmallLayoutSubject.asObservable();
    this.elementsOfQuestionnaire$ = this.questionnaireStore.elementsOfQuestionnaire$;
    this.elementsOfSkill$ = this.skillStore.elementsOfSkill$;
  }

  public get helper() {
    return this.helperService;
  }

  @Input()
  set _elementsType(_elementsType: 'questionnaires' | 'skills') {
    if (_elementsType) {
      this.elementsType = _elementsType;
    }
  }

  @Input()
  set _studyId(_studyId: number) {
    if (_studyId) {
      this.studyId = _studyId;
    }
  }

  @Input()
  set _lesson(_lesson: LessonInterface) {
    if (_lesson) {
      this.lesson = _lesson;
    }
  }

  @Input()
  set _skill(_skill: SkillInterface) {
    if (_skill) {
      this.skill = _skill;
    }
  }

  @Input()
  set _diary(_diary: DiaryInterface) {
    if (_diary) {
      this.diary = _diary;
    }
  }

  @Input()
  set _background_color(_backgroundColor: string) {
    if (_backgroundColor) {
      this.backgroundColor = _backgroundColor;
    }
  }

  @Input()
  set _answers(_answers: AnswersheetAnswerInterface[]) {
    if (_answers) {
      this.answers = _answers;
    }
  }

  @Input()
  set _dynamicAnswers(_dynamicAnswers: AnswersheetAnswerInterface[]) {
    if (_dynamicAnswers) {
      this.dynamicAnswers = _dynamicAnswers;
    }
  }

  @Input()
  set _isDiary(_isDiary: boolean) {
    if (_isDiary !== undefined) {
      this.isDiary = _isDiary;
    }
  }

  @Input()
  set _diaryDefault(_diaryDefault: string) {
    if (_diaryDefault !== undefined) {
      this.diaryDefaultImageColor = _diaryDefault;
    }
  }

  @Input()
  set _intervention(_intervention: InterventionInterface) {
    if (_intervention !== undefined) {
      this.intervention = _intervention;
    }
  }

  @Input()
  set _skillId(_skillId: number) {
    if (_skillId !== undefined) {
      this.skillId = _skillId;
    }
  }

  @Input()
  set _inputElements(_elements: ElementInterface[]) {
    if (_elements != null) {
      this.inputElements = _elements;
    } else {
      this.inputElements = null;
    }
  }

  ngOnInit(): void {
    this.setupLocales();
    this.subscriptions.push(
      this.getElementsOfItem().subscribe((_result) => {
        this.identifyBlocksAndConditionals();

        if (!this.answers) {
          this.dynamicAnswers$.pipe(distinctUntilChanged()).subscribe((resp: AnswersheetAnswerInterface[]) => {
            this.dynamicAnswers = resp;
            this.calculatePageElements(resp);
            this.components.forEach(element => {
              element._currentPage = this.currentPageNumber;
            });
            if (this.progressBarComponent) {
              this.progressBarComponent._currentPage = this.currentPageNumber;
              this.progressBarComponent._allPages = this.pageIteration;
            }
          });
        } else {
          const _answers = this.parserService.parseAnswersheetToAnswer(this.answers, this.elements);
          this.calculatePageElements(_answers);
        }

        setTimeout(() => {
          this.components = [];
          if (this.elementsContainer) {
            this.elementsContainer.clear();
          }

          if (this.progressBarContainer) {
            this.progressBarContainer.clear();
          }

          this.progressBarComponent = this.progressBarContainer.createComponent(ProgressBarComponent).instance;
          this.progressBarComponent._intervention = this.intervention;
          this.progressBarComponent._currentPage = this.currentPageNumber;
          this.progressBarComponent._allPages = this.pageIteration;
          this.progressBarComponent._answers = this.answers;
          this.progressBarComponent._pages = this.pages;

          const _answers: AnswersheetAnswerInterface[] = this.answers
            ? this.parserService.parseAnswersheetToAnswer(this.answers, this.elements)
            : this.dynamicAnswers;

          this.nonNestedElements.forEach((element) => {
            // Create the initial component dynamically inside the ng-template
            const component = this.getComponent(element, _answers);
            if (component) {
              this.components = [...this.components, component];
            }
          });
        });
      })
    );

    this.subscriptions.push(
      this.translateService.onLangChange.pipe(
        mergeMap((_event: LangChangeEvent) => this.getElementsOfItem()),
      )
      .subscribe((_result) => {}),
    );
  }

  private setLocales(locales: string[]) {
    this.locales = locales;
    const localLessonLocale = localStorage.getItem('lessonLocale');
    if (this.locales.includes(localLessonLocale)) {
      this.selectedLocale = localLessonLocale;
    } else {
      const localLanguage = localStorage.getItem('language');
      if (this.locales.includes(localLanguage)) {
        this.selectedLocale = localLanguage;
      } else {
        this.selectedLocale = this.locales.length > 0 ? this.locales[0] : '';
      }
    }
  }

  private isNonEmptyArray(array: any): array is any[] {
    return Array.isArray(array) && array.length > 0;
  }

  private setupLocales() {
    if (this.lesson) {
      const lessonLocales = this.lesson.attributes?.locales;
      if (this.isNonEmptyArray(lessonLocales)) {
        this.setLocales(lessonLocales);
      } else if (this.isDiary) {
        const diaryLocales = this.diary?.attributes?.locales;
        if (this.isNonEmptyArray(diaryLocales)) {
          this.setLocales(diaryLocales);
        }
      } else {
        this.setLocales([]);
      }
    } else if (this.skill) {
      const skillLocales = this.skill.attributes?.locales;
      if (this.isNonEmptyArray(skillLocales)) {
        this.setLocales(skillLocales);
      } else {
        this.setLocales([]);
      }
    } else {
      this.setLocales([]);
    }
  }

  private getComponent(element: ElementInterface, answers: AnswersheetAnswerInterface[]) {
    if (element.elementtype === 'elements/questions') {
      return this.getQuestionComponent(element, answers);
    } else {
      if (element.name === 'HEADLINE') {
        const component = this.elementsContainer.createComponent(QuestionHeadlineComponent).instance;
        if (this.answers) {
          component._answers = answers;
        }
        component._condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._allElements = this.elements;
        component._page = this.getPageByElementPosition(element.position, answers);
        return component;
      } else if (element.name === 'MEDIA') {
        const component = this.elementsContainer.createComponent(QuestionMediaComponent).instance;
        if (this.answers) {
          component._answers = answers;
        }
        component._condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._allElements = this.elements;
        component._page = this.getPageByElementPosition(element.position, answers);
        return component;
      } else if (element.elementtype === 'elements/texts') {
        const component = this.elementsContainer.createComponent(QuestionTextComponent).instance;
        if (this.answers) {
          component._answers = answers;
        }
        component._condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._allElements = this.elements;
        component._page = this.getPageByElementPosition(element.position, answers);
        return component;
      } else if (element.elementtype === 'elements/pages') {
        const component = this.elementsContainer.createComponent(ElementsPageComponent).instance;
        if (this.answers) {
          component._answers = answers;
        }
        component._condition = this.blocks;
        component._element = element;
        component._page = this.getPageByElementPosition(element.position, answers);
        this.pages.push(component);
        return component;
      } else if (element.elementtype === 'elements/lines') {
        const component = this.elementsContainer.createComponent(ElementsLinesComponent).instance;
        component.condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._page = this.getPageByElementPosition(element.position, answers);
        return component;
      } else if (element.elementtype === 'elements/spaces') {
        const component = this.elementsContainer.createComponent(ElementsSpacesComponent).instance;
        component.condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._page = this.getPageByElementPosition(element.position, answers);
        return component;
      } else if (element.elementtype === 'elements/blockopens') {
        const component = this.elementsContainer.createComponent(ElementsBlockopensComponent).instance;
        if (this.answers) {
          component._answers = answers;
        }
        component.condition = this.blocks;
        component._currentPage = this.currentPageNumber;
        component._element = element;
        component._elements = this.elements;
        component._nested = 0;
        component._pageIteration = this.pageIteration;
        component._page = this.getPageByElementPosition(element.position, answers) + 1;
        component._color = this.backgroundColor;
        return component;
      }
    }
    return undefined;
  }

  private getQuestionComponent(element: ElementInterface, answers: AnswersheetAnswerInterface[]) {
    const component = this.getQuestionComponentInstance(element);
    if (component) {
      if (this.answers) {
        component._answers = answers;
      }
      component._condition = this.blocks;
      component._currentPage = this.currentPageNumber;
      component._element = element;
      component._allElements = this.elements;
      component._page = this.getPageByElementPosition(element.position, answers);
    }
    return component;
  }

  private getQuestionComponentInstance(element: ElementInterface) {
    switch (element.questiontype) {
      case 'MultipleChoice':
        return this.elementsContainer.createComponent(QuestionMultipleChoiceComponent).instance;
      case 'SingleChoice':
        return this.elementsContainer.createComponent(QuestionSingleChoiceComponent).instance;
      case 'Slider':
        return this.elementsContainer.createComponent(QuestionSliderComponent).instance;
      case 'QuestionTable':
        return this.elementsContainer.createComponent(QuestionTableComponent).instance;
      case 'TextArea':
        return this.elementsContainer.createComponent(QuestionTextAreaComponent).instance;
      case 'TextDate':
        return this.elementsContainer.createComponent(QuestionTextDateComponent).instance;
      case 'TextString':
        return this.elementsContainer.createComponent(QuestionTextStringComponent).instance;
      case 'YesNoSwitch':
        return this.elementsContainer.createComponent(QuestionYesNoComponent).instance;
      default:
        return undefined;
    }
  }

  public getElementsOfItem(): Observable<ElementInterface[]> {
    if (this.elementsType === 'questionnaires') {
      let elements: Observable<ElementInterface[]>;
      if (this.inputElements !== null) {
        elements = of(this.inputElements);
      } else {
        this.questionnaireStore.getElementsOfQuestionnaire({ questionnaireId: this.lesson.id });
        elements = this.elementsOfQuestionnaire$.pipe(filter((value) => value.length > 0));
      }
      return elements.pipe(
        mergeMap((result: ElementInterface[]) => {
          this.elements = result;
          if (this.isDiary) {
            this.backgroundColor = this.diaryDefaultImageColor;
          } else {
            this.backgroundColor = this.lesson.attributes.page_color;
          }
          return of(this.elements);
        }),
      );
    } else if (this.elementsType === 'skills') {
      let elements: Observable<ElementInterface[]>;
      if (this.inputElements !== null) {
        elements = of(this.inputElements);
      } else {
        this.skillStore.getSkillElements({ id: this.skillId });
        elements = this.elementsOfSkill$.pipe(skip(1), take(1));
      }
      return elements.pipe(
        mergeMap((result: ElementInterface[]) => {
          this.elements = result;
          return of(this.elements);
        }),
      );
    } else {
      return of([]);
    }
  }

  public toggleSmallLayout(): void {
    this.isSmallLayoutSubject.next(!this.isSmallLayoutSubject.value);
  }

  // Get all non-encapsulated elements outside of (conditional) blocks
  public getNonEncapsulatedElements(): ElementInterface[] {
    const nonEncapElements: ElementInterface[] = [];
    for (let i = 0; i < this.elements.length; ) {
      const element = this.elements[i];
      nonEncapElements.push(element);
      if (element.elementtype === 'elements/blockopens') {
        const loopBlock = this.blocks.find((cond) => cond.blockOpen === element.position);
        if (loopBlock) {
          i = loopBlock.blockClose - 1;
        }
      } else {
        i++;
      }
    }
    return nonEncapElements;
  }

  public getPageByElementPosition(position: number, answers: AnswersheetAnswerInterface[]): number {
    const nextPageElements: PageIterationInterface[] = [];
    const previousPageElements: PageIterationInterface[] = [];
    for (const page of this.pageIteration) {
      if (page.position > position) {
        nextPageElements.push(page);
      } else if (page.position < position) {
        previousPageElements.push(page);
      }
    }
    if (nextPageElements.length > 0) {
      const nextPageElementPosition = nextPageElements.reduce(
        (minimum: number, page) => (page.position < minimum ? page.position : minimum),
        nextPageElements[0].position,
      );
      const allArrMin = this.pageIteration.filter((page) => page.position === nextPageElementPosition);
      if (allArrMin.length > 0) {
        const nextPage = allArrMin.reduce((min, page) => (min.iteration < page.iteration ? min : page));
        const evaluationNextPage = this.evaluationService.evaluate(this.blocks, nextPage.position, answers);
        // Added page condition
        if (evaluationNextPage && nextPage.evaluatedValue) {
          return nextPage.page - 1;
        }
      }
    }
    if (previousPageElements.length > 0) {
      const currentPageElementPosition = previousPageElements.reduce(
        (maximum: number, page) => (page.position > maximum ? page.position : maximum),
        previousPageElements[0].position,
      );
      const allArrMax = this.pageIteration.filter((page) => page.position === currentPageElementPosition);
      if (allArrMax.length > 0) {
        const currentPage = allArrMax.reduce((max, page) => (max.iteration > page.iteration ? max : page));
        const evaluationCurrentPage = this.evaluationService.evaluate(this.blocks, currentPage.position, answers);
        // Added page condition
        if (evaluationCurrentPage && currentPage.evaluatedValue) {
          return currentPage.page;
        }
      }
    }
    return 0;
  }

  public showTopPage(selectedPage: number): void {
    if (this.topPage) {
      this.topPage.nativeElement.scrollIntoView();
    }
    const navigation: 'next' | 'previous' = this.currentPageNumber < selectedPage ? 'next' : 'previous';
    const foundPageElementIndex = this.pageIteration.findIndex(
      (pageIteration) => pageIteration.page.toString() === selectedPage.toString(),
    );

    if (foundPageElementIndex !== -1) {
      if (this.pageIteration[foundPageElementIndex].evaluatedValue) {
        this.currentPageNumber = selectedPage;
      } else {
        let foundPageElement: PageIterationInterface;
        if (navigation === 'next') {
          foundPageElement = this.pageIteration
            .slice(selectedPage)
            .find((pageIteration) => pageIteration.evaluatedValue);
        } else {
          const index = this.findLastIndex(
            this.pageIteration.slice(0, selectedPage),
            (pageIteration) => pageIteration.evaluatedValue,
          );
          if (index > -1) {
            foundPageElement = this.pageIteration[index];
          }
        }
        this.currentPageNumber = foundPageElement ? foundPageElement.page : 0;
      }
    } else {
      this.currentPageNumber = selectedPage;
    }
    this.setPageBackground();
    this.components.forEach((element) => {
      element._currentPage = this.currentPageNumber;
    });
    if (this.progressBarComponent) {
      this.progressBarComponent._currentPage = this.currentPageNumber;
      this.progressBarComponent._allPages = this.pageIteration;
    }
  }

  public setPageBackground(): void {
    const pageIterationElement = this.pageIteration.find(
      (value) => value.page.toString() === this.currentPageNumber.toString(),
    );
    const pageElementPos = pageIterationElement !== undefined ? pageIterationElement.position : -1;
    const getPageElement = this.elements.find((element) => element.position.toString() === pageElementPos.toString());
    if (getPageElement !== undefined && getPageElement.color !== '' && this.backgroundColor !== undefined) {
      this.backgroundColor = getPageElement.color;
    } else {
      if (!this.isDiary) {
        if (this.lesson) {
          this.backgroundColor = this.lesson.attributes.page_color;
        }
      } else {
        this.backgroundColor = this.diaryDefaultImageColor;
      }
    }
  }

  public getRepetition(repetition: number, condition: ConditionalblockInterface, answers: AnswersheetAnswerInterface[]): number {
    let reps = repetition;
    if (condition.condition.thenBlock.repeat.question) {
      const resultFromDefault = this.elements.find(
        (element) => element.position === condition.condition.thenBlock.repeat.data,
      );
      const resultFromAnswer = answers.find(
        answer => answer.position === condition.condition.thenBlock.repeat.data
      );
      if (resultFromAnswer !== undefined) {
        if (resultFromAnswer.value) {
          reps = reps * parseInt(resultFromAnswer.value, 10);
        }
      } else {
        reps = reps * parseInt(resultFromDefault.values.min, 10);
      }
    } else {
      reps = reps * condition.condition.thenBlock.repeat.data;
    }
    return reps;
  }

  getBackgroundStyle() {
    if (this.backgroundColor === null || this.backgroundColor === undefined) {
      return null;
    }
    if (this.helper.isHexColor(this.backgroundColor) || this.backgroundColor === '') {
      return { 'background-color': this.backgroundColor };
    } else {
      const imageUrl = `url(${this.helper.getAllMediaSupportPath(this.backgroundColor, this.studyId)})`;
      return {
        'background-image': imageUrl,
        'background-size': 'cover',
        'background-attachment': 'fixed',
      };
    }
  }

  public hasEvaluatedPage(navigation: 'next' | 'previous') {
    if (navigation === 'next') {
      return this.pageIteration.slice(this.currentPageNumber).some((page) => page.evaluatedValue);
    } else {
      const lastIndex = this.findLastIndex(
        this.pageIteration.slice(0, this.currentPageNumber),
        (page) => page.evaluatedValue,
      );
      return lastIndex > -1;
    }
  }

  public getPageNumber() {
    const foundPageIterationIndex = this.pageIteration
      .filter((page) => page.evaluatedValue)
      .findIndex((page) => page.page === this.currentPageNumber);
    return foundPageIterationIndex > -1 ? foundPageIterationIndex + 2 : 1;
  }

  public onChange(): void {
    localStorage.setItem('lessonLocale', this.selectedLocale);
    this.store.dispatch({
      type: LessonLocaleActionTypes.setLessonLocaleType,
      payload: this.selectedLocale
    });
  }

  public ngOnDestroy(): void {}

  // Get all nested elements regardless of block position to searchFilter elements out that are nested
  // TODO Recalculate page elements in nested condition and loops
  private calculatePageElements(answers: AnswersheetAnswerInterface[]): void {
    // Non nested elements in array of arrays
    this.nonNestedElements = this.getNonEncapsulatedElements();

    // All element pages
    const pageElements = this.elements.filter((element) => element.elementtype === 'elements/pages');
    this.numbersOfPages.pageElements = pageElements;

    // TODO Need to add those not part of any conditions
    this.pageIteration = [];

    this.numbersOfPages.pageElements.forEach((element) => {
      // Evaluate page condition;
      let pageCondition = true;
      if (element.condition && element.condition.toString() !== '') {
        pageCondition = this.evaluationService.evaluateCondition(element.condition, answers);
      }

      // const evaluation = this.evaluationService.evaluate(this.blocks, element.position, answers) && pageCondition;
      const evaluation = this.evaluationService.evaluate(this.blocks, element.position, answers);
      if (evaluation) {
        const repetition = this.evaluateLoop(this.blocks, element.position, answers);
        if (repetition === 1) {
          // Ignore first element which is the page to support old published interventions
          if (element.position !== 1) {
            this.pageIteration.push({
              page: this.pageIteration.length + 1,
              position: element.position,
              iteration: 0,
              evaluatedValue: pageCondition,
            });
          }
        } else {
          for (let i = 0; i < repetition; i++) {
            this.pageIteration.push({
              page: this.pageIteration.length + 1,
              position: element.position,
              iteration: i,
              evaluatedValue: pageCondition,
            });
          }
        }
      }
    });
  }

  // Get all pairs of blockOpens and blockCloses elements
  private identifyBlocksAndConditionals(): void {
    const blockOpenPosLocal: number[] = [];
    const conditionalsLocal: ConditionElementInterface[] = [];
    const conditionalTypeLocal: string[] = [];
    this.blocks = [];
    this.elements.forEach((arr) => {
      if (arr.elementtype === 'elements/blockopens') {
        blockOpenPosLocal.push(arr.position);
        conditionalsLocal.push(arr.condition);
        conditionalTypeLocal.push(arr.type);
      } else if (arr.elementtype === 'elements/blockcloses') {
        this.blocks.push({
          blockOpen: blockOpenPosLocal.pop(),
          blockClose: arr.position,
          condition: conditionalsLocal.pop(),
          condition_type: conditionalTypeLocal.pop(),
        });
      }
    });
  }

  // Evaluate all conditional elements for this lesson with the given answers
  private evaluateLoop(
    conditions: ConditionalblockInterface[],
    position: number,
    answers: AnswersheetAnswerInterface[],
  ): number {
    let repetition = 1;
    conditions.forEach((condition) => {
      if (condition.blockOpen < position && position < condition.blockClose) {
        if (condition.condition_type.match(/^(conditional|both|none|details)$/)) {
          repetition = this.getRepetition(repetition, condition, answers);
        }
      }
    });
    return repetition;
  }

  private findLastIndex<T>(array: T[], predicate: (value: T, index: number, obj: T[]) => boolean): number {
    for (let i = array.length - 1; i >= 0; i--) {
      if (predicate(array[i], i, array)) {
        return i;
      }
    }
    return -1;
  }
}
